import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-home",
  "use": "icon-mobile-home-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-home\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19.675 10.3251V22.6751H13.325V16.6751H10.675V22.6751H4.325V10.3251H19.675ZM18.325 11.6751H5.675V21.3251H9.325V15.3251H14.675V21.3251H18.325V11.6751ZM12 1.82922L23 10.9651L22.9907 10.9729L21.7581 12.0001L12 3.86722L2.24194 12.0001L1.00931 10.9729L1 10.9651L11.984 1.84822L12 1.82922Z\" fill=\"#000018\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol